import React from "react";

interface ScriptProps {
  children: React.ReactNode;
  className?: string;
  color?: string;
  swooshColor?: string;
  size?: string;
}

/** Handwritten tagline (Dancing Script) with a hand-drawn blue swoosh underline. */
export const Script: React.FC<ScriptProps> = ({
  children,
  className = "",
  color = "#2563eb",
  swooshColor = "#2563eb",
  size = "text-3xl",
}) => {
  return (
    <div className={`relative inline-block leading-tight ${className}`}>
      <span className={`font-script ${size} font-semibold`} style={{ color }}>
        {children}
      </span>
      <svg
        className="mt-0.5 block w-full"
        height="10"
        viewBox="0 0 160 10"
        fill="none"
        preserveAspectRatio="none"
      >
        <path
          d="M2 7C40 2 120 2 158 6"
          stroke={swooshColor}
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
};

export default Script;
